import {
  // eslint-disable-next-line settle/preferred-modules
  Select as MuiSelect,
  FormControl as MuiFormControl,
  formHelperTextClasses,
  inputLabelClasses,
  selectClasses,
  outlinedInputClasses,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { youShallNotPass } from 'lib/helpers/youShallNotPass/youShallNotPass'
import * as tkns from '../../tokens/common/Input'

interface FormControlProps {
  warning?: boolean
}

export const FormControl = styled(MuiFormControl, {
  shouldForwardProp: youShallNotPass('warning'),
})<FormControlProps>(({ theme, size, warning }) => ({
  ...(warning && {
    '& .MuiOutlinedInput-root:not(.Mui-focused):not(.Mui-disabled)': {
      '& fieldset, &:hover fieldset': {
        borderColor: theme.tokens.ThemeColorCommonWarning,
      },
    },
  }),
  [`& .${inputLabelClasses.root}`]: {
    ...(size === 'small' && {
      transform: 'translate(8px, 6px) scale(1)',
    }),
    ...(size === 'medium' && {
      transform: 'translate(12px, 10px) scale(1)',
    }),
  },
  [`& .${inputLabelClasses.root}.${inputLabelClasses.shrink}`]: {
    ...(size === 'small' && {
      transform: 'translate(8px, -9px) scale(0.75)',
    }),
    ...(size === 'medium' && {
      transform: 'translate(12px, -9px) scale(0.75)',
    }),
  },
  [`& .${formHelperTextClasses.root}`]: {
    ...(size === 'small' && {
      marginLeft: '8px',
    }),
    ...(size === 'medium' && {
      marginLeft: '12px',
    }),
  },
}))

export const Select = styled(MuiSelect)(({ size }) => ({
  [`&& .${selectClasses.select}`]: {
    boxSizing: 'border-box',
    ...(size === 'small' && {
      minHeight: tkns.InputBaseSizeSmallMinHeight,
      padding: '6px 32px 6px 8px',
    }),
    ...(size === 'medium' && {
      minHeight: tkns.InputBaseSizeMediumMinHeight,
      padding: '10px 32px 10px 12px',
    }),
  },
  [`&& .${outlinedInputClasses.notchedOutline}`]: {
    ...(size === 'small' && {
      paddingLeft: '2px',
    }),
    ...(size === 'medium' && {
      paddingLeft: '6px',
    }),
  },
})) as unknown as typeof MuiSelect // allows passing generic type to the styled component
